import React, { useState } from "react";
import PropTypes from "prop-types";

const YearPicker = ({ selectedYear, onChange }) => {
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(selectedYear);

  const handleChange = (e) => {
    const selectedYear = parseInt(e.target.value);
    setYear(selectedYear);
    if (onChange) {
      onChange(selectedYear);
    }
  };

  // Generate years range from 1990 to current year
  const years = Array.from({ length: currentYear - 1960 + 1 }, (_, index) => 1960 + index);

  return (
    <>
   
    <select className="form-select" value={year} onChange={handleChange}>
      <option value="selected">Select</option>
      {years.map((year) => (
        <option key={year} value={year}>
          {year}
        </option>
      ))}
    </select>
    </>
  );
};

YearPicker.propTypes = {
  selectedYear: PropTypes.number, 
  onChange: PropTypes.func, 
};

export default YearPicker;

